export default __webpack_public_path__ + "media/metronic/_theme/media/demos/demo4/footer-2027bdb80cfbe40e15acf12a1f6787da.jpg";